import { t } from 'utils/localize';
import { Row, Align, Justify, Button, Image } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from 'types/ClassName';
import { openInNewTab } from 'utils/windowUtils';
import useAppSwitcherAnalytics from 'hooks/analytics/useAppSwitcherAnalytics';

export interface IWebAppSwitcherRowProps {
  appIconSrc: string;
  appName: string;
  appMktUrl: string;
  appLoginUrl: string;
  className?: ClassName;
}

export default function WebAppSwitcherRow({
  appIconSrc,
  appName,
  appMktUrl,
  appLoginUrl,
  className,
}: IWebAppSwitcherRowProps) {
  const analytics = useAppSwitcherAnalytics();

  type AppName = 'ToolWatch' | 'FleetWatcher' | 'SafetyReports' | 'BusyBusy';

  const isValidAppName = (name: string): name is AppName => {
    return ['ToolWatch', 'FleetWatcher', 'SafetyReports', 'BusyBusy'].includes(name);
  };

  const handleLoginClick = () => {
    openInNewTab(appLoginUrl);
    if (isValidAppName(appName)) {
      switch (appName) {
        case 'ToolWatch':
          analytics.recordToolWatchLoginClick();
          break;
        case 'FleetWatcher':
          analytics.recordFleetWatcherLoginClick();
          break;
        case 'SafetyReports':
          analytics.recordSafetyReportsLoginClick();
          break;
        case 'BusyBusy':
          analytics.recordBusyBusyLoginClick();
          break;
      }
    }
  };

  const handleLearnMoreClick = () => {
    openInNewTab(appMktUrl);
    if (isValidAppName(appName)) {
      switch (appName) {
        case 'ToolWatch':
          analytics.recordToolWatchLearnMoreClick();
          break;
        case 'FleetWatcher':
          analytics.recordFleetWatcherLearnMoreClick();
          break;
        case 'SafetyReports':
          analytics.recordSafetyReportsLearnMoreClick();
          break;
        case 'BusyBusy':
          analytics.recordBusyBusyLearnMoreClick();
          break;
      }
    }
  };

  return (
    <Row justify={Justify.SPACE_BETWEEN} align={Align.CENTER} className={classNames('row-container', className)}>
      <div className="left-content">
        <Button onClick={handleLoginClick}>
          <Image className="icon" src={appIconSrc} />
          <span>{appName}</span>
        </Button>
      </div>
      <div className="right-content">
        <Button onClick={handleLearnMoreClick}>
          <span className="marketing-link ">{t('Learn More')}</span>
        </Button>
      </div>
    </Row>
  );
}
